import { render, staticRenderFns } from "./BagShoppingIcon.vue?vue&type=template&id=5e751684&scoped=true&"
import script from "./BagShoppingIcon.vue?vue&type=script&lang=js&"
export * from "./BagShoppingIcon.vue?vue&type=script&lang=js&"
import style0 from "./BagShoppingIcon.vue?vue&type=style&index=0&id=5e751684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e751684",
  null
  
)

export default component.exports